<button type="button" (click)="onClick()" mat-raised-button [color]="color" [disabled]="disabled"
    [title]="hintTranslateKey || titleTranslateKey | translate">
    <span *ngIf="iconClass" class="fal fa-fw fa-material" [ngClass]="iconClass">&nbsp;</span>{{titleTranslateKey |
    translate}}
</button>